<div class="phone-buttons w-100" data-automation="phone-buttons">
  <ul
    ngbNav
    #nav="ngbNav"
    class="nav nav-tabs"
    [ngClass]="{ 'single-button': isSingleButton }"
    [destroyOnHide]="false"
    [(activeId)]="active"
    data-automation="phone-buttons-nav-tab"
  >
    <!-- Primary Buttons Tab -->
    @if (!isSingleButton) {
      <li [ngbNavItem]="expansionTabId.PRIMARY_BUTTONS" [attr.data-automation]="expansionTabId.PRIMARY_BUTTONS">
        <button ngbNavLink class="btn" [disabled]="isPending || isSaving">
          {{ 'tkey;shared.device.phone.phone_buttons.primary.button.tab.title' | translate }}
        </button>
        <ng-template ngbNavContent>
          @if (showCopyUdpButton()) {
            <ziro-button
              class="mr-2"
              [dataAutomation]="'copy-button-from-existing-extension-mobility'"
              [label]="'tkey;shared.device.phone.phone_buttons.primary.button.tab.copy_button.label' | translate"
              [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
              [icon]="ziroIcons.COPY"
              [isDisabled]="isPending || isSaving || !isCopyUdpButtonEnabled()"
              [tooltip]="disabledCopyUdpButtonTooltip()"
              [isTooltipDisabled]="isCopyUdpButtonEnabled()"
              (clicked)="onClickCopyUdpButtons()"
            ></ziro-button>
          }
          <ziro-phone-buttons-standard
            class="w-100"
            [isPending]="isPending || isSaving"
            [buttons]="standardButtons"
            [phone]="phone"
            [siteId]="siteId()"
            [serverId]="serverId()"
            [phoneUI]="phoneUI"
            [userMode]="userMode()"
            [global360View]="global360View()"
            [isAutomaticPhoneTemplateSelectionEnabled]="isAutomaticPhoneButtonTemplateSelectionEnabled()"
            [buttonStates]="buttonStates"
            (singleButtonWasUpdated)="updateSingleButton($event)"
            (singleButtonWasDeleted)="deleteSingleButton($event)"
            [attr.data-automation]="'standard-buttons'"
            [isButtonSwapped]="isButtonSwapped"
            [closePopover$]="closePopover$"
            (popoverOpened)="onPopoverOpened($event)"
            (secondaryLineIsUpdating)="onSecondaryLineUpdating($event)"
            (buttonStateIsInvalid)="handleInvalidButtonState()"
            [phoneType]="phoneType()"
            [endUserRef]="endUserRef()"
          ></ziro-phone-buttons-standard>
        </ng-template>
      </li>
    }

    @for (tab of expansionModuleTabs; track tab; let i = $index) {
      <li
        [ngbNavItem]="expansionTabId.ADD_MODULE + i"
        class="nav-item d-flex"
        [attr.data-automation]="expansionTabId.ADD_MODULE"
      >
        <button
          ngbNavLink
          (click)="changeActiveTab(i)"
          [attr.data-automation]="expansionTabId.ADD_MODULE + i"
          class="btn expansion-module-tab"
          [disabled]="isPending || isSaving"
          [ngClass]="{
            'nav-item__last-item': canDisplayKemDropdown() && i === expansionModuleTabs.length - 1,
          }"
        >
          {{ ('tkey;shared.device.phone.phone_buttons.expansion.module.tab.title' | translate) + (i + 1) }}
        </button>
        @if (canDisplayKemDropdown() && i === expansionModuleTabs.length - 1) {
          <button
            type="button"
            class="btn btn-close ms-n4 nav-item__close-tab"
            [disabled]="isPending || isSaving"
            [attr.data-automation]="'expansion-module-tab-close'"
            (click)="onRemoveKem($event, i)"
          ></button>
        }
        <ng-template ngbNavContent>
          <ziro-loading-block
            [hidden]="!isAddingNewKem"
            data-automation="phone-buttons-loading-block"
          ></ziro-loading-block>
          @if (!isAddingNewKem) {
            <div class="container-fluid">
              <div class="row mt-3">
                <div class="col">
                  @if (isKemTitleDisplayed) {
                    <div
                      class="text-center expansion-module-title"
                      [ngClass]="'expansion-module-title-' + i"
                      [attr.data-automation]="'expansion-module-title'"
                    >
                      {{ tab }}
                    </div>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <ziro-phone-buttons-standard
                    class="my-2"
                    [isPending]="isPending || isSaving"
                    [userMode]="userMode()"
                    [phone]="phone"
                    [siteId]="siteId()"
                    [serverId]="serverId()"
                    [buttons]="expansionButtons[i]?.buttons"
                    [phoneUI]="expansionButtons[i]?.expansionUI"
                    [global360View]="global360View()"
                    [isAutomaticPhoneTemplateSelectionEnabled]="isAutomaticPhoneButtonTemplateSelectionEnabled()"
                    [buttonStates]="buttonStates"
                    (singleButtonWasUpdated)="updateSingleButton($event)"
                    (singleButtonWasDeleted)="deleteSingleButton($event)"
                    [attr.data-automation]="'phone-expansion-module-buttons-' + (i + 1)"
                    [isButtonSwapped]="isButtonSwapped"
                    [closePopover$]="closePopover$"
                    (popoverOpened)="onPopoverOpened($event)"
                    (secondaryLineIsUpdating)="onSecondaryLineUpdating($event)"
                    (buttonStateIsInvalid)="handleInvalidButtonState()"
                    [phoneType]="phoneType()"
                    [endUserRef]="endUserRef()"
                  ></ziro-phone-buttons-standard>
                </div>
              </div>
            </div>
          }
        </ng-template>
      </li>
    }

    <!-- Add a new KEM -->
    @if (isAutomaticPhoneButtonTemplateSelectionEnabled() && !selectedModule && supportedKems.length > 1) {
      <li
        [ngbNavItem]="expansionTabId.ADD_MODULE"
        class="nav-item dropdown"
        ngbDropdown
        [attr.data-automation]="'add-new-module-tab'"
      >
        <button
          [innerHtml]="'tkey;shared.device.phone.phone_buttons.add.expansion.module.tab.title' | escapeHtml"
          class="btn nav-link dropdown-toggle"
          [disabled]="isPending || isSaving"
          ngbDropdownToggle
          data-toggle="dropdown"
          role="button"
        ></button>
        <div ngbDropdownMenu class="dropdown-menu add-new-tab">
          @for (model of supportedKems; track model; let i = $index) {
            <div>
              <a class="btn dropdown-item" [attr.data-automation]="'dropdown-item-' + i" (click)="addNewTab(model)">
                {{ model }}
              </a>
            </div>
          }
        </div>
      </li>
    }

    <!-- Add another existing KEM -->
    @if (canDisplayKemDropdown() && (!!selectedModule || supportedKems.length <= 1) && !isSingleButton) {
      <li
        [ngbNavItem]="expansionTabId.ADD_MODULE"
        class="nav-item dropdown add-new-module"
        ngbDropdown
        [ngClass]="{
          'nav-item dropdown disabled nav-tabs--disabled': !canAddMoreExpansionModule() || isAddingNewKem,
          'nav-item dropdown': canAddMoreExpansionModule() && !isAddingNewKem,
          'ps-0': supportedKems.length === 1 && expansionModuleTabs.length === 0,
        }"
        [tooltipClass]="'add-new-kem-tooltip'"
        [ngbTooltip]="getAddTabDisabledTooltip() | translate"
        [disableTooltip]="canAddMoreExpansionModule()"
        [attr.data-automation]="'add-new-module-tab'"
      >
        @if (!canAddMoreExpansionModule() || isAddingNewKem) {
          <div
            ngbNavLink
            class="disabled-tab"
            [innerHtml]="'tkey;shared.device.phone.phone_buttons.expansion.module.tab.single_module.title' | escapeHtml"
          ></div>
        }
        @if (canAddMoreExpansionModule() && !isAddingNewKem) {
          <button
            ngbNavLink
            class="btn"
            [disabled]="isPending || isSaving"
            (click)="addNewTab(selectedModule)"
            [innerHtml]="'tkey;shared.device.phone.phone_buttons.expansion.module.tab.single_module.title' | escapeHtml"
          ></button>
        }
      </li>
    }

    <!-- Phone with one button -->
    @if (isSingleButton) {
      <li class="single-button d-flex justify-content-center">
        <ziro-phone-buttons-standard
          class="w-100"
          [isPending]="isPending || isSaving"
          [buttons]="standardButtons"
          [phone]="phone"
          [siteId]="siteId()"
          [serverId]="serverId()"
          [phoneUI]="phoneUI"
          [userMode]="userMode()"
          [global360View]="global360View()"
          [isAutomaticPhoneTemplateSelectionEnabled]="isAutomaticPhoneButtonTemplateSelectionEnabled()"
          [buttonStates]="buttonStates"
          (singleButtonWasUpdated)="updateSingleButton($event)"
          (singleButtonWasDeleted)="deleteSingleButton($event)"
          [attr.data-automation]="'standard-buttons'"
          [isButtonSwapped]="isButtonSwapped"
          [closePopover$]="closePopover$"
          (popoverOpened)="onPopoverOpened($event)"
          (secondaryLineIsUpdating)="onSecondaryLineUpdating($event)"
          (buttonStateIsInvalid)="handleInvalidButtonState()"
          [phoneType]="phoneType()"
          [endUserRef]="endUserRef()"
        ></ziro-phone-buttons-standard>
      </li>
    }
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
